import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import reviewStars from './four-and-a-half-stars.svg';
import Translation from '../../../../components/stateless/Translation';
import SMFacilityLink from '../SMFacilityLink';

import styles from './styles.scss';

const propTypes = {
  facility: PropTypes.shape().isRequired,
  multiLocale: PropTypes.bool.isRequired,
};

const defaultProps = {};

const Reviews = ({
  facility,
  multiLocale,
}) => (
  <div className={styles.reviewsContainer}>
    <img src={reviewStars} type="image/svg+xml" className={styles.starsIcon} alt="stars" />
    <div className={styles.reviewsText}>
      <SMFacilityLink
        facility={facility}
        multiLocale={multiLocale}
        anchorTag="readreviews"
      >
        <Translation
          id="widgets.facilityList.readReviews"
          defaultMessage="Read Reviews"
        />
      </SMFacilityLink>
    </div>
  </div>
);

Reviews.propTypes = propTypes;
Reviews.defaultProps = defaultProps;

Reviews.fragments = {
  facility: gql`
    fragment ReviewsFacility on Facility {
      id
    }
  `,
};

export default Reviews;
